import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { IEmployeeLoginCredentials } from 'pm-src/app/models/iemployeelogin-credentials';
import { Employee } from 'pm-src/app/models/employee';
import { IEmployeePolicyRoles } from 'pm-src/app/types/i-employee-policy-roles';

export const EMPLOYEE_AUTH_SERVICE_IMPL = new InjectionToken<IEmployeeAuthService>(
    'employeeAuthServiceImpl'
);

export interface IEmployeeAuthService {
    readonly currentEmployee: Employee;
    employee$: Observable<Employee>;
    login(
        loginCredentials: IEmployeeLoginCredentials
    ): Observable<HttpResponse<Employee>>;
    logout(): Observable<HttpResponse<void>>;
    hasActiveEmployee(): boolean;
    getPolicyRoles(): IEmployeePolicyRoles[];
    removeCurrentEmployee(): void;
    getEmployeeFromStorage(): Employee;
}
